import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, Share2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function Flyers() {
  const [flyers, setFlyers] = useState(null);
  useEffect(() => { api.get("/branding").then((r) => setFlyers(r.data.flyers || [])).catch(() => setFlyers([])); }, []);

  const share = async (f) => {
    const url = `${window.location.origin}/flyers`;
    if (navigator.share) { try { await navigator.share({ title: "Dr.Gadget flyer", text: `${f.title} — Dr.Gadget, expert tech support by phone or video. 310-422-0669`, url }); } catch { /* cancelled */ } return; }
    try { await navigator.clipboard.writeText(url); toast.success("Link copied — paste it into a text or email"); } catch { toast.error("Couldn't copy — the address is " + url); }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16" data-testid="flyers-page">
      <span className="dg-eyebrow">Dr.Gadget flyers</span>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold font-display tracking-tight">Grab a flyer, pass it on.</h1>
      <p className="mt-4 text-slate-300 text-base sm:text-lg max-w-2xl">Download any flyer to print or post, or share this page with a friend who needs real, reachable tech help. Call <a href="tel:+13104220669" className="dg-link">310-422-0669</a> or email <a href="mailto:David@docdrgadget.com" className="dg-link">David@docdrgadget.com</a>.</p>

      {flyers === null && <div className="mt-10 text-slate-400">Loading flyers…</div>}
      {flyers?.length === 0 && <div className="mt-10 text-slate-400" data-testid="flyers-empty">No flyers posted yet — check back soon.</div>}
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {flyers?.map((f, i) => (
          <div key={f.id} className={`dg-card rounded-2xl p-4 flex flex-col gap-4 dg-reveal dg-reveal-${(i % 4) + 1}`} data-testid={`flyer-card-${f.id}`}>
            <img src={`${BASE}${f.url}?w=800`} srcSet={`${BASE}${f.url}?w=480 480w, ${BASE}${f.url}?w=800 800w, ${BASE}${f.url}?w=1200 1200w`} sizes="(max-width: 640px) 92vw, (max-width: 1024px) 45vw, 30vw" alt={f.title} loading="lazy" decoding="async" className="w-full rounded-xl ring-1 ring-slate-700/60 bg-slate-900 object-contain" />
            <div className="text-sm text-slate-300">{f.title}</div>
            <div className="mt-auto grid grid-cols-2 sm:flex sm:flex-wrap gap-2">
              <a href={`${BASE}${f.download || f.url}`} download={`Dr.Gadget-flyer-${f.id}.png`} className="dg-btn-primary rounded-full px-4 py-2.5 text-xs flex items-center justify-center gap-1.5" data-testid={`flyers-download-${f.id}`}>
                <Download className="w-3.5 h-3.5" /> Download
              </a>
              <button type="button" onClick={() => share(f)} className="dg-btn-ghost rounded-full px-4 py-2.5 text-xs flex items-center justify-center gap-1.5" data-testid={`flyers-share-${f.id}`}>
                <Share2 className="w-3.5 h-3.5" /> Share
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-14 flex flex-wrap items-center gap-4">
        <Link to="/book" className="dg-btn-primary rounded-full px-6 py-3 text-sm flex items-center gap-2" data-testid="flyers-book-btn">Book a Session <ArrowRight className="w-4 h-4" /></Link>
        <Link to="/ask" className="dg-btn-ghost rounded-full px-6 py-3 text-sm" data-testid="flyers-ask-btn">Ask Dr.Gadget a question</Link>
      </div>
    </div>
  );
}
